"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrSchedule = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const fdr_lib_misc_schedule_1 = require("@hotelplan/fdr.lib.misc.schedule");
const fdr_schedule_opening_status_1 = require("./fdr-schedule-opening-status");
const fdr_schedule_styles_1 = require("./fdr-schedule.styles");
const UPDATING_OPEN_STATUS_INTERVAL = 5 * 1000;
function FdrSchedule({ openingHours, showStatus = true, showStatusIcon, timezone, mapCustomOpeningHoursToSchedules, className, testId, }) {
    const [t] = (0, next_i18next_1.useTranslation)('agency');
    const [opened, setOpened] = (0, react_1.useState)(() => {
        const currentDate = new Date();
        return openingHours
            ? (0, fdr_lib_misc_schedule_1.isDateShiftIncluded)((0, fdr_lib_misc_schedule_1.getCurrentOpeningHours)(openingHours, currentDate).shifts, timezone, currentDate)
            : false;
    });
    const updateOpenedState = (0, react_1.useCallback)(() => {
        const currentDate = new Date();
        const currentHours = (0, fdr_lib_misc_schedule_1.getCurrentOpeningHours)(openingHours, currentDate);
        setOpened((0, fdr_lib_misc_schedule_1.isDateShiftIncluded)(currentHours.shifts, timezone, currentDate));
    }, [openingHours, timezone]);
    (0, react_1.useEffect)(function updateOpenedStateEffect() {
        const intervalID = setInterval(updateOpenedState, UPDATING_OPEN_STATUS_INTERVAL);
        return function cleanupInterval() {
            clearInterval(intervalID);
        };
    }, [updateOpenedState]);
    const mapFunction = mapCustomOpeningHoursToSchedules
        ? mapCustomOpeningHoursToSchedules
        : fdr_lib_misc_schedule_1.mapOpeningHoursToSchedules;
    if (!openingHours)
        return null;
    return (react_1.default.createElement(fdr_schedule_styles_1.FdrScheduleWrapper, { opened: opened, className: className, "data-id": testId },
        showStatus && (react_1.default.createElement(fdr_schedule_opening_status_1.FdrScheduleOpeningStatus, { opened: opened, showStatusIcon: showStatusIcon })),
        react_1.default.createElement("div", { className: "help-overlay-opening-hours-title" },
            t('openingHours.title'),
            ' '),
        react_1.default.createElement("div", { "data-id": "fdr-help-overlay-opening-hours" }, mapFunction(t, openingHours).map((item, index) => {
            return (react_1.default.createElement("div", { key: index, className: "help-overlay-opening-hours-item", "data-id": "fdr-help-overlay-opening-hours-day" }, item));
        }))));
}
exports.FdrSchedule = FdrSchedule;
//# sourceMappingURL=fdr-schedule.js.map